import { createTopic, ConfigActions } from '../lib';
import { z } from 'zod';

const descriptorDownloadedEventSchema = z.object({
  entityUrn: z
    .string()
    .describe('The URN of the entity which descriptor has been downloaded.'),
  kind: z.string().describe('The kind of the entity.'),
  environment: z
    .string()
    .describe(
      'The environment in which the system has been deployed. This field is filled in when the entity whose descriptor was downloaded is a system.',
    )
    .optional(),
  parentSystem: z
    .object({
      urn: z.string().describe('The URN of the parent system.'),
      environment: z
        .string()
        .describe(
          'The environment in which the parent system has been deployed.',
        ),
    })
    .optional(),
});

export type DescriptorDownloadedEvent = z.infer<
  typeof descriptorDownloadedEventSchema
>;

export const descriptorDownloadedTopic = createTopic<DescriptorDownloadedEvent>(
  {
    namespace: 'marketplace',
    name: 'descriptor-downloaded',
    description: 'User downloaded the descriptor of an entity.',
  },
  descriptorDownloadedEventSchema,
  s => [
    { action: ConfigActions.HASH, path: s.entityUrn },
    { action: ConfigActions.HASH, path: s.parentSystem.urn },
  ],
);
